import { useRefreshUsage } from '@/modules/Billing/useRefreshUsage'
import { createSharedComposable } from '@vueuse/core'
import { ref } from 'vue'

export const useSidebar = createSharedComposable(() => {
  const isOpen = ref(true)

  const { refreshUsage, hasSkippedRefresh } = useRefreshUsage()

  function toggle() {
    isOpen.value = !isOpen.value

    if (isOpen.value && hasSkippedRefresh.value) {
      // We show plan usage in the sidebar, so refresh it when the sidebar is
      // opened to ensure it's up to date.
      refreshUsage()
    }
  }

  return { isOpen, toggle }
})
